/**
 * @generated SignedSource<<16076e90ec75077eae7f703c0b48db8f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuStoneCutSelect_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAppliedFilterUrlLabel_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuStoneCutSelect_itemSearch";
};
export type SbRespRefineMenuStoneCutSelect_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuStoneCutSelect_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuStoneCutSelect_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuStoneCutSelect_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAppliedFilterUrlLabel_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "74b92bff63b7a2c32c76fb9b504732bb";

export default node;
